import { createTheme, Theme } from "@mui/material/styles";

export const OrangeGradient = (direction: string) =>
	`linear-gradient(to ${direction}, #c56f6b, #e5c665)`;
export const PurpleGradient = (direction: string) =>
	`linear-gradient(to ${direction}, #5468d5, #a36db0)`;
export const BrownGradient = (direction: string) =>
	`linear-gradient(to ${direction}, #6D4C41, #ff9800)`;
export const BlueGradient = (direction: string) =>
	`linear-gradient(to ${direction}, #1976d2, #dc004e)`;
export const DarkGradient = (direction: string) =>
	// `linear-gradient(to ${direction}, #171457, #ffeb3b)`;
	// `linear-gradient(to ${direction}, #191554, #a36db0)`;
	`linear-gradient(to ${direction}, #4f47e2, #a374ef)`;

export const customGradient = (direction: string, primaryColor: string, secondaryColor: string) =>
	`linear-gradient(to ${direction}, ${primaryColor}, ${secondaryColor})`;


const softLightShadows: Theme["shadows"] = [
	"none",
	"0px 1px 2px rgba(16, 24, 40, 0.06), 0px 1px 3px rgba(16, 24, 40, 0.10)",
	"0px 2px 4px rgba(16, 24, 40, 0.06), 0px 2px 8px rgba(16, 24, 40, 0.10)",
	"0px 4px 6px rgba(16, 24, 40, 0.06), 0px 4px 12px rgba(16, 24, 40, 0.10)",
	"0px 6px 10px rgba(16, 24, 40, 0.06), 0px 6px 18px rgba(16, 24, 40, 0.10)",
	"0px 8px 12px rgba(16, 24, 40, 0.06), 0px 8px 24px rgba(16, 24, 40, 0.10)",
	"0px 10px 14px rgba(16, 24, 40, 0.06), 0px 10px 28px rgba(16, 24, 40, 0.10)",
	"0px 12px 16px rgba(16, 24, 40, 0.06), 0px 12px 32px rgba(16, 24, 40, 0.10)",
	"0px 14px 18px rgba(16, 24, 40, 0.06), 0px 14px 36px rgba(16, 24, 40, 0.10)",
	"0px 16px 20px rgba(16, 24, 40, 0.06), 0px 16px 40px rgba(16, 24, 40, 0.10)",
	"0px 18px 22px rgba(16, 24, 40, 0.06), 0px 18px 44px rgba(16, 24, 40, 0.10)",
	"0px 20px 24px rgba(16, 24, 40, 0.06), 0px 20px 48px rgba(16, 24, 40, 0.10)",
	"0px 22px 26px rgba(16, 24, 40, 0.06), 0px 22px 52px rgba(16, 24, 40, 0.10)",
	"0px 24px 28px rgba(16, 24, 40, 0.06), 0px 24px 56px rgba(16, 24, 40, 0.10)",
	"0px 26px 30px rgba(16, 24, 40, 0.06), 0px 26px 60px rgba(16, 24, 40, 0.10)",
	"0px 28px 32px rgba(16, 24, 40, 0.06), 0px 28px 64px rgba(16, 24, 40, 0.10)",
	"0px 30px 34px rgba(16, 24, 40, 0.06), 0px 30px 68px rgba(16, 24, 40, 0.10)",
	"0px 32px 36px rgba(16, 24, 40, 0.06), 0px 32px 72px rgba(16, 24, 40, 0.10)",
	"0px 34px 38px rgba(16, 24, 40, 0.06), 0px 34px 76px rgba(16, 24, 40, 0.10)",
	"0px 36px 40px rgba(16, 24, 40, 0.06), 0px 36px 80px rgba(16, 24, 40, 0.10)",
	"0px 38px 42px rgba(16, 24, 40, 0.06), 0px 38px 84px rgba(16, 24, 40, 0.10)",
	"0px 40px 44px rgba(16, 24, 40, 0.06), 0px 40px 88px rgba(16, 24, 40, 0.10)",
	"0px 42px 46px rgba(16, 24, 40, 0.06), 0px 42px 92px rgba(16, 24, 40, 0.10)",
	"0px 44px 48px rgba(16, 24, 40, 0.06), 0px 44px 96px rgba(16, 24, 40, 0.10)",
	"0px 46px 50px rgba(16, 24, 40, 0.06), 0px 46px 100px rgba(16, 24, 40, 0.10)",
];

const global: Theme = createTheme({
	typography: {
		fontFamily: ["Inter", "sans-serif"].join(","),
		fontSize: 12,
	},
	palette: {
		divider: "#e2e2e2",
	},
	shadows: softLightShadows,
	components: {
		// MuiCssBaseline: {
		//   styleOverrides: {
		//     body: {
		//       backgroundColor: "#FAACA8",
		//       backgroundImage: `linear-gradient(19deg, #FAACA8 0%, #DDD6F3 100%)`,
		//     },
		//   },
		// },
		MuiListItemText: {
			styleOverrides: {
				primary: {
					fontSize: "0.875rem",
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: "none",
				},
			},
		},
		MuiTabs: {
			styleOverrides: {
				root: {
					minHeight: 40,
					height: 40,
				},
			},
		},
		MuiTab: {
			styleOverrides: {
				root: {
					textTransform: "none",
					minWidth: 90,
					height: 40,
					minHeight: 40,
					padding: "5px 10px",
					fontSize: "0.775rem",
					lineHeight: 2.2,
					"&.Mui-selected": {
						fontWeight: 700,
					},
				},
			},
		},
	},
});

export const lightTheme: Theme = createTheme({
	...global,
	palette: {
		mode: "light",
		primary: {
			main: "#1976d2",
		},
		secondary: {
			main: "#dc004e",
		},
	},
});

export const darkTheme: Theme = createTheme({
	...global,
	palette: {
		mode: "dark",
		primary: {
			main: "#4f47e2",
		},
		secondary: {
			main: "#ffeb3b",
		},
		background: {
			default: "#101010",
			// default: "#191a22",
			paper: "#1d1d1d",
		},
		divider: "#515151",
	},
	components: {
		...global.components,
		MuiPaper: {
			styleOverrides: {
				root: {
					backgroundColor: "#1d1d1d",
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				...global.components?.MuiButton?.styleOverrides,
				text: {
					color: "#fff",
					backgroundColor: "#1d1d1d",
				},
				// contained: {
				//   color: "#fff",
				//   background: DarkGradient("right"),
				//   "&:hover": {
				//     background: DarkGradient("left"),
				//   },
				//   transition: "background 0.3s",
				// },
			},
		},
		// MuiTable: {
		//   styleOverrides: {
		//     root: {
		//       backgroundColor: "#1d1d1d",
		//     },
		//   },
		// },
		MuiList: {
			styleOverrides: {
				root: {
					"& .Mui-selected": {
						background: DarkGradient("right"),
						color: "#fff",
					},
				},
			},
		},
		// MuiSelect: {
		//   styleOverrides: {
		//     root: {
		//       backgroundColor: "#1d1d1d",
		//     },
		//   },
		// },
		MuiTab: {
			styleOverrides: {
				root: {
					// @ts-ignore
					...(global.components?.MuiTab?.styleOverrides?.root || {}),
					backgroundColor: "#1d1d1d",
					color: "#fff",
					"&.Mui-selected": {
						color: "#fff",
						opacity: 1,
						backgroundColor: "transparent",
					},
				},
			},
		},
		MuiTabs: {
			styleOverrides: {
				root: {
					// @ts-ignore
					...(global.components?.MuiTabs?.styleOverrides?.root || {}),
					"& .MuiTabs-indicator": {
						height: 2,
						background: DarkGradient("right"),
					},
				},
			},
		},
	},
});

export const Orange: Theme = createTheme({
	...global,
	palette: {
		mode: "light",
		primary: {
			main: "#EF6C00",
		},
		secondary: {
			main: "#8bc34a",
		},
	},
	components: {
		...global.components,
		MuiList: {
			styleOverrides: {
				root: {
					"& .Mui-selected": {
						background: OrangeGradient("right"),
						color: "#fff",
					},
				},
			},
		},
		MuiTabs: {
			...global.components?.MuiTabs,
			styleOverrides: {
				root: {
					// @ts-ignore
					...(global.components?.MuiTabs?.styleOverrides?.root || {}),
					"& .MuiTabs-indicator": {
						height: 2,
						background: OrangeGradient("right"),
					},
				},
			},
		},
	},
});

export const Purple: Theme = createTheme({
	...global,
	palette: {
		mode: "light",
		primary: {
			main: "#6633D1",
		},
		secondary: {
			main: "#ffeb3b",
		},
	},
	components: {
		...global.components,
		MuiButton: {
			styleOverrides: {
				...global.components?.MuiButton?.styleOverrides,
				contained: {
					background: PurpleGradient("right"),
					"&:hover": {
						background: PurpleGradient("left"),
					},
					transition: "background 0.3s",
				},
			},
		},
		MuiList: {
			styleOverrides: {
				root: {
					"& .Mui-selected": {
						background: PurpleGradient("right"),
						color: "#fff",
					},
				},
			},
		},
		MuiTabs: {
			...global.components?.MuiTabs,
			styleOverrides: {
				root: {
					// @ts-ignore
					...(global.components?.MuiTabs?.styleOverrides?.root || {}),
					"& .MuiTabs-indicator": {
						height: 2,
						background: PurpleGradient("right"),
					},
				},
			},
		},
	},
});

export const Brown: Theme = createTheme({
	...global,
	palette: {
		mode: "light",
		primary: {
			main: "#6D4C41",
		},
		secondary: {
			main: "#ff9800",
		},
	},
});

interface ThemeData {
	name: string;
	mode: "light" | "dark";
	primaryColor: string;
	secondaryColor: string;
	isCustom: boolean;
}

export const createCustomTheme = (themeData: ThemeData) => {
	return createTheme({
		...global,
		palette: {
			mode: themeData.mode,
			primary: {
				main: themeData.primaryColor,
			},
			secondary: {
				main: themeData.secondaryColor,
			},
		},
		components: {
			...global.components,
			MuiList: {
				styleOverrides: {
					root: {
						"& .Mui-selected": {
							background: customGradient(
								"right",
								themeData.primaryColor,
								themeData.secondaryColor
							),
							color: "#fff",
						},
					},
				},
			},
			MuiTabs: {
				...global.components?.MuiTabs,
				styleOverrides: {
					root: {
						// @ts-ignore
						...(global.components?.MuiTabs?.styleOverrides?.root || {}),
						"& .MuiTabs-indicator": {
							height: 2,
							background: customGradient(
								"right",
								themeData.primaryColor,
								themeData.secondaryColor
							),
						},
					},
				},
			},
		},
	});
};
